import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined } from '../../../app/core/utils';

@Pipe({
  name: 'localDate'
})
export class LocalDatePipe extends DatePipe implements PipeTransform {
  transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null;
  transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;
  
  transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null {

    if (isNullOrUndefined(format)) {
      format = 'dd-MMM-yyyy, h:mm:ss a';
    }
    return super.transform(value, format, timezone, locale);
  }

}
